<template>
    <div class="user-wrapper">
        <a-button type="primary"  @click="$router.back()">返回</a-button>
        <a @click="handleChange" v-if="showFullScreenBtn">
            <span class="action">
                <a-icon :type="!isFull ? `fullscreen` : `fullscreen-exit`" />
            </span>
        </a>
        <!--<notice-icon class="action"/>-->

        <a-dropdown >
            <a-menu slot="overlay" style="max-height: 400px; overflow-y: auto;" @click="handleMenuItemClick" :selectedKeys="[selectedKey]">
                <a-menu-item v-for="item in menuItems" :key="item.app_id" :disabled="item.disabled" >
                    {{ item.name }}
                </a-menu-item>
            </a-menu>
            <a-button>{{btnTip}}<a-icon type="down"/></a-button>
        </a-dropdown>

        <a-dropdown>
            <span class="action ant-dropdown-link user-dropdown-menu">
                <a-avatar class="avatar" size="small" :src="avatar()" />
                <span>{{ nickname() }}</span>
            </span>
            <a-menu slot="overlay" class="user-dropdown-menu-wrapper">
                <!--<a-menu-item key="1">
                    <router-link :to="{ name: 'settings' }">
                        <a-icon type="setting"/>
                        <span>账户设置</span>
                    </router-link>
                </a-menu-item>-->
                <a-menu-item key="3">
                    <a href="javascript:;" @click="handleLogout">
                        <a-icon type="logout" />
                        <span>退出登录</span>
                    </a>
                </a-menu-item>
            </a-menu>
        </a-dropdown>
    </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import User from "@/api/User";
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios';

export default {
    name: 'UserMenu',
    data() {
        return {
            isFull: false,
            menuItems: [], // 用于存储从后端获取的菜单项
            selectedKey: "0",
            btnTip: '基础样板App(母库)',
        }
    },
    computed: {
        showFullScreenBtn() {
            return window.navigator.userAgent.indexOf('MSIE') < 0
        }
    },
    components: {
        NoticeIcon
    },
    created() {

        User.app_list().then(res => {
            this.menuItems = res.result.map((value, key) => {
                return { ...value, key}
            })
            this.selectedKey = res.appInfo.app_id.toString();
            this.btnTip = res.appInfo.name;
        })

        let isFullscreen =
            document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.fullScreen ||
            document.mozFullScreen ||
            document.webkitIsFullScreen
        isFullscreen = !!isFullscreen
        document.addEventListener('fullscreenchange', () => {
            this.isFull = !this.isFull
        })
        document.addEventListener('mozfullscreenchange', () => {
            this.isFull = !this.isFull
        })
        document.addEventListener('webkitfullscreenchange', () => {
            this.isFull = !this.isFull
        })
        document.addEventListener('msfullscreenchange', () => {
            this.isFull = !this.isFull
        })
    },
    methods: {
        ...mapActions(['Logout']),
        ...mapGetters(['nickname', 'avatar', 'nickid']),
        handleFullscreen() {
            let main = document.body
            if (this.isFull) {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
            } else {
                if (main.requestFullscreen) {
                    main.requestFullscreen()
                } else if (main.mozRequestFullScreen) {
                    main.mozRequestFullScreen()
                } else if (main.webkitRequestFullScreen) {
                    main.webkitRequestFullScreen()
                } else if (main.msRequestFullscreen) {
                    main.msRequestFullscreen()
                }
            }
        },
        handleChange() {
            this.handleFullscreen()
        },
        handleLogout() {
            const that = this

            this.$confirm({
                title: '提示',
                content: '确定退出登录吗 ?',
                onOk() {
                    return that
                        .Logout({})
                        .then(() => {
                            window.location.reload()
                        })
                        .catch(err => {
                            that.$message.error({
                                title: '错误',
                                description: err.message
                            })
                        })
                },
                onCancel() {}
            })
        },


        handleMenuItemClick(e) {
            const { key } = e; // 获取被点击的菜单项的key
            const that = this
             User.app_detail({'app_id': key}).then(res => {
                 this.selectedKey = res.result.app_id.toString();
                 this.btnTip = res.result.name;
             }).then(() => {
                 window.location.reload()
             })
        },


    }
}
</script>
